import React, { useEffect, useState } from 'react'
import { Segment } from 'tea-component'

// import './inSegmentMetricsComponentdex.scss'

interface Props {
	value?: string
	options?: any[]
  onChange?: (metrics) => void
}

const SegmentMetrics = (props: Props) => {
	const {
		value: valueProps = '',
		options = [],
		onChange
	} = props
  const [value, setValue] = useState(valueProps)

	const handleChange = (value) => {
		onChange?.(value)
		setValue(value)
	}

	useEffect(() => {
		setValue(value)
	}, [valueProps])

  return (
    <>
      <Segment className='segment-light dbd-segment-metrics' value={value.toString()} onChange={handleChange} options={options} />
    </>
  )
}

export default SegmentMetrics;